import { inject, Service } from '@angular/core';
import { UnleashFlags } from '@thiememeulenhoff/types';
import { UnleashService } from '@thiememeulenhoff/ng-sdk';
import { ServicesService } from '../services';

@Service()
export class ArrangementsEndpointsService {
  readonly #service = inject(ServicesService);

  readonly #unleash = inject(UnleashService);

  public arrangements() {
    if (this.#unleash.isEnabled(UnleashFlags.UseVestaArrangements)) {
      return this.#service.vesta('arrangement');
    }

    return this.#service.thip('arrangement');
  }
}
